import { GetServerSidePropsContext } from 'next';
import { NextPage } from 'next';
import React from 'react';
import { cachedFetchOrgForms } from '../../api/fetchOrgForms';
import { FetchOrgFormsResponse } from '../../api/fetchOrgForms';
import { cachedFetchOrgTypes } from '../../api/fetchOrgTypes';
import { FetchOrgTypesResponse } from '../../api/fetchOrgTypes';
import { AnnouncesIndexQuery } from '../../api/fetchPurchases';
import { useResetBreadcrumbs } from '../../components/_shared/Breadcrumbs/BreadcrumbsContext';
import { Auth } from '../../components/Auth';
import { Registration } from '../../components/Auth/Registration/Registration';
import { Services } from '../../types';
import { Region } from '../../types/entities';

interface Props {
    orgTypes: FetchOrgTypesResponse;
    orgForms: FetchOrgFormsResponse;
    regions: Region[];
}

const RegistrationPage: NextPage<Props> = ({ orgTypes, orgForms, regions }) => {
    useResetBreadcrumbs();

    return (
        <Auth activeTab="registration">
            <Registration
                orgTypes={orgTypes}
                orgForms={orgForms}
                regions={regions}
            />
        </Auth>
    );
};

export default RegistrationPage;

export const getServerSideProps = async (
    context: GetServerSidePropsContext<AnnouncesIndexQuery> & {
        req: { services: Services };
    }
) => {
    context.res.setHeader(
        'Cache-Control',
        'public, s-maxage=10, stale-while-revalidate=59'
    );

    const [orgTypes, orgForms] = await Promise.all([
        cachedFetchOrgTypes(),
        cachedFetchOrgForms(),
    ]);

    return {
        props: {
            orgTypes,
            orgForms,
            regions: context.req.services.references.regions,
        },
    };
};
